import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type RefAccessBarKind = 'library' | 'import';

@Component({
  selector: 'app-ref-access-bar',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ref-access-bar.component.html',
  styleUrls: ['./ref-access-bar.component.scss'],
})
export class RefAccessBarComponent {
  @Input({ required: true }) kind: RefAccessBarKind = 'library';
  /** Nothing to reach behind the bar (empty library) — renders inert with an explanatory tooltip. */
  @Input() disabled = false;
  @Input() tooltip: string | null = null;
  @Input() frozen = false;

  @Output() open = new EventEmitter<void>();

  get labelKey(): string {
    return this.kind === 'library' ? 'tenders.responses.documents.advanced.library-bar' : 'tenders.responses.documents.advanced.import-bar';
  }

  get icon(): string {
    return this.kind === 'library' ? 'ph-books' : 'ph-upload-simple';
  }

  onClick(): void {
    if (this.frozen || this.disabled) return;
    this.open.emit();
  }
}
